import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import System from "../../../../helper/system";
import BOM from "@system/config/bom";
import NumericInput from 'react-numeric-input';
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import { isObject } from "underscore";
import { useBOMStore } from "../../../../hooks/bom";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Constants from 'src/helper/Constants';

const bomId = System.getParams().bomId;

const BomRematchData = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ row_selected_number, bom_data_list_main_copy }, {get_Display_Status_For_Finish_Columns }, { set_saved_columns_preference_by_bom_id, SET_bomDataList_based_on_ROW_selected, set_is_rematch_flag }] = useBOMStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    let ColumnsForFinish = useSelector((state) => state.entities.system.stateToRedux['setColumnsForFinish']);
    const { storageName } = System
    const { translation:t } = System;
    const showOnlyForApac = System.avUserInfoData.speedBoatAbbr == Constants.speedBoats.apacAbbr
    
    useEffect(() => {
        // Check LocalStorage Variables & Remove 
        if (localStorage.getItem(storageName.FLASH_MESSAGE_REMATCH)) {
            system_alert_indicator({
                name: 'FLASH_MESSAGE_REMATCH',
                message: localStorage.getItem(storageName.FLASH_MESSAGE_REMATCH),
                type: 'warning'
            })
            localStorage.removeItem(storageName.FLASH_MESSAGE_REMATCH);
        }
    }, [])
    const finishColumns = async () => {
        let columnMappingList = [];
        if (Object.entries(ColumnsForFinish).length > 0) {
            Object.entries(ColumnsForFinish).map((v) => {
                columnMappingList.push({
                    bomColumnName: v[1].bomColumnName,
                    columnName: v[1].columnName,
                });
            });
            await set_saved_columns_preference_by_bom_id({ bomId, row_selected_number, columnMappingList });
            await set_is_rematch_flag({ bomId: bomId })
            window.location.href = BOM.getBomDetailByIdRouteURL(bomId)
        }
    };
    const displayFinishColoum = get_Display_Status_For_Finish_Columns();
    return (
        <>
            <div className="row bs5">
                <div className="col-sm-12">
                    <h4>{t('defineColumnHeaders')}</h4>
                    <p>{t('defineColumnHeadersToMatchData')}<b className="px-1">{t('manufacturePartNumber')}{showOnlyForApac && (<><span className="text-uppercase"> {t('or')} </span>{t('customerPartNumber')}</>)}</b> {t('isRequired')}</p>
            </div>
            <div className="col-12">
                {!displayFinishColoum.validation_flags.mpn_cpn_available &&
                    <div className="bs5 alert alert-warning">
                        {t('pleaseDefineTheColumnFor')} <b className={'px-1'}> {t('manufacturePartNumber')} {showOnlyForApac && (<><span className="text-uppercase"> {t('or')} </span>{t('customerPartNumber')}</>)}</b> {t('toContinue')}
                    </div>
                }
                {!displayFinishColoum.validation_flags.unique_column_selected &&
                    <div className="bs5 alert alert-warning">
                        {t('columnShouldBeSelectedUnique')}
                    </div>
                }
            </div>

            <>

                <div className="col-12 mb-2"
                    style={__check(['BOM_REMATCH_API_CALL', 'BOM_REMATCH_SAVED_API_CALL', 'BOM_REMATCH_OPERATION_API_CALL']).status ? { display: 'none' } : {}}>
                    <b>{t('selectTheRowThatYourPartsDataBegins')}</b>
                </div>
                <div className="col-12 mb-3"
                    style={__check(['BOM_REMATCH_API_CALL', 'BOM_REMATCH_SAVED_API_CALL']).status ? { display: 'none' } : {}}>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="d-flex align-items-center">
                                <span className="pe-3 text-nowrap">{t('dataStartsOnRow')}</span>
                                <div className="numberbox">
                                    <NumericInput className="form-control form-control-sm w60 py-0"
                                        value={row_selected_number}
                                        min={1}
                                        max={(bom_data_list_main_copy && isObject(bom_data_list_main_copy)) ? Object.entries(bom_data_list_main_copy).length : 1}
                                        onChange={(value) => {
                                            if (!value) {
                                                value = 0;
                                            }
                                            if (value < 1) {
                                                value = 1;
                                            }
                                            let m = (bom_data_list_main_copy && isObject(bom_data_list_main_copy)) ? Object.entries(bom_data_list_main_copy).length : 1;
                                            if (value >= m) {
                                                value = m;
                                            }
                                            SET_bomDataList_based_on_ROW_selected(value)
                                        }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 text-right">
                            <button
                                className={__check(['BOM_REMATCH_OPERATION_API_CALL']).status ? "ms-auto bs5 btn btn-primary d-none" : "ms-auto bs5 btn btn-primary"}
                                onClick={async () => {
                                    if (displayFinishColoum.displayStatus) {
                                        await finishColumns()
                                    }
                                }}
                                disabled={!displayFinishColoum.displayStatus}
                            >{t('finishedColumnMatching')}
                            </button>
                        </div>
                    </div>
                </div>
            </>
        </div >
        </>
    );
}

export default BomRematchData;